import { PaginationRightContainer } from '../styled-components.js'

export const PaginationRight = ({ selectedItems = null }) => {
  return (
    <PaginationRightContainer>
      {selectedItems != null && (
        <>
          <span>
            <span>{selectedItems}</span>
          </span>
          <span>selected</span>
        </>
      )}
    </PaginationRightContainer>
  )
}

export default PaginationRight
